'use client';

import type { CurrentUserHrContext } from '@/app/hr/components/types';

interface MeCertificationsTabProps { ctx: CurrentUserHrContext; }

const MeCertificationsTab = ({ ctx }: MeCertificationsTabProps) => {
  if (ctx.certifications.length === 0) {
    return (
      <div className="p-8 rounded-lg border border-dashed border-gray-200 text-center">
        <p className="text-[13px] font-semibold text-gray-600">No certifications on file</p>
        <p className="text-[11px] text-gray-400 mt-1">Contact HR to add training certificates or licenses.</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {ctx.certifications.map(cert => {
        const isExpired = cert.status === 'expired';
        const expiringSoon = !!cert.expiration_date &&
          new Date(cert.expiration_date).getTime() < Date.now() + 60 * 24 * 60 * 60 * 1000 &&
          new Date(cert.expiration_date).getTime() > Date.now();

        return (
          <div key={cert.id} className={`rounded-lg border p-3 ${
            isExpired ? 'border-red-200 bg-red-50' : expiringSoon ?'border-amber-200 bg-amber-50': 'border-gray-200 bg-white'
          }`}>
            <div className="flex items-start justify-between gap-2 mb-1">
              <p className="text-[13px] font-bold text-[#1C2E5E]">{cert.certification_name}</p>
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-bold ${
                cert.status === 'active' ? 'bg-green-100 text-green-700' :
                cert.status === 'expired'? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-600'
              }`}>{cert.status.toUpperCase()}</span>
            </div>
            {cert.issuing_organization && <p className="text-[11px] text-gray-500">{cert.issuing_organization}</p>}
            <div className="grid grid-cols-2 gap-2 mt-2 text-[11px]">
              {cert.issued_date && (
                <div>
                  <span className="text-[9px] uppercase tracking-wide text-gray-500 font-bold">Issued</span>
                  <p className="text-gray-700">{new Date(cert.issued_date).toLocaleDateString()}</p>
                </div>
              )}
              {cert.expiration_date && (
                <div>
                  <span className="text-[9px] uppercase tracking-wide text-gray-500 font-bold">Expires</span>
                  <p className={`font-medium ${isExpired ? 'text-red-700' : expiringSoon ? 'text-amber-700' : 'text-gray-700'}`}>
                    {new Date(cert.expiration_date).toLocaleDateString()}
                  </p>
                </div>
              )}
            </div>
            {expiringSoon && <p className="mt-2 text-[10px] font-bold text-amber-700">⚠ Expiring within 60 days</p>}
            {isExpired && <p className="mt-2 text-[10px] font-bold text-red-700">⚠ EXPIRED</p>}
          </div>
        );
      })}
    </div>
  );
};

export default MeCertificationsTab;
